import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var MarkerPin05 = function MarkerPin05(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 13.3744c3.5318.6944 6 2.2803 6 4.1256 0 2.4853-4.4772 4.5-10 4.5S2 19.9853 2 17.5c0-1.8453 2.4682-3.4312 6-4.1256M12 17V3l5.3177 3.2724c.3879.2387.5818.358.6437.5084a.5.5 0 0 1-.0117.407c-.0705.1465-.271.2544-.672.4703L12 10.5"
    })
  }));
};
export default MarkerPin05;